export default function Layout({ children, className = "" }) {
  return (
    <div
      className={`px-[14px] sm:px-7 md:px-8 lg:px-12 xl:px-[60px] ${className}`}
    >
      {children}
    </div>
  );
}
